import Constant from '@/const';
import axios from 'axios';

const getWaitingListPatient = async params => {
  try {
    const response = await axios.get(
      Constant.apiUrl.concat('/letter/control-inpatient-letter/all'),
      { params },
    );
    return response;
  } catch (error) {
    const err = error;
    throw err;
  }
};

export default getWaitingListPatient;
